import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import SiteVisitFormsList from "./pages/SiteVisitFormsList";
import "bootstrap/dist/css/bootstrap.min.css";
import FormWizard from "./pages/FormWizard";
import ThankYou from "./pages/ThankYou";
import MainLayout from "./components/MainLayout";
import LeadReassign from "./pages/LeadReassign.jsx";
import LeadDetailsById from "./components/LeadDetailsById";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* FormWizard - protected but separate from MainLayout */}
        <Route
          path="/companies/:companyId/site_visit_forms/:formId/view"
          element={
            <ProtectedRoute>
              <FormWizard />
            </ProtectedRoute>
          }
        />

        {/* Thank You Page */}
        <Route
          path="/companies/:companyId/site_visit_forms/:formId/thank-you"
          element={
            <ProtectedRoute>
              <ThankYou />
            </ProtectedRoute>
          }
        />

        {/* protected layout with nested routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<SiteVisitFormsList />} />
          <Route path="companies/:companyId/lead-reassign" element={<LeadReassign />} />
          {/* <Route path="companies/:companyId/lead-details" element={<LeadDetailsById />} /> */}
          {/* add other protected child routes here */}
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
